import type { Component } from 'vue';

import FileIcon from './FileIcon.vue';
import Plus from './Plus.vue';

export default new Map<string, Component>([
  ['FileIcon', FileIcon],
  ['Plus', Plus],
]);